export default __webpack_public_path__ + "static/media/omam2_logo.09f57e72.png";